// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#waiter-progress-history-edit[data-v-7257efd4]{max-width:800px;margin-left:auto;margin-right:auto}#waiter-progress-history-edit .cancel-btn[data-v-7257efd4],#waiter-progress-history-edit .update-btn[data-v-7257efd4]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
